import { render, staticRenderFns } from "./BIControl.vue?vue&type=template&id=daf8bb74&lang=html&"
import script from "./BIControl.vue?vue&type=script&lang=js&"
export * from "./BIControl.vue?vue&type=script&lang=js&"
import style0 from "./BIControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports